import React, { forwardRef } from 'react';
import { SwitchParent, SwitchWrapper } from './Switch.styles';

interface SwitchProps extends React.ComponentPropsWithoutRef<'input'> {
  checked?: boolean;
  varient?: 'small' | 'default';
  className?: string;
}

const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ checked, onChange, varient, className }, ref) => (
    <SwitchParent className={className}>
      <input type="checkbox" ref={ref} onChange={onChange} />
      <SwitchWrapper checked={checked} size={varient}>
        <div />
      </SwitchWrapper>
    </SwitchParent>
  )
);

Switch.displayName = 'Switch';
export default Switch;
